/** @jsx jsx */
import { jsx } from "@emotion/react";
import React from "react";

export type VisuallyHiddenProps = {
  children: React.ReactNode;
  handleSpace?: "default" | "reserve" | "overlay";
};

const VisuallyHidden = (props: VisuallyHiddenProps): React.ReactElement => {
  const { handleSpace = "default", children } = props;
  if (handleSpace === "default") {
    return (
      <span
        css={{
          "&:not(:focus):not(:focus-within):not(:active)": {
            position: "absolute",
            height: 1,
            width: 1,
            border: 0,
            padding: 0,
            margin: 0,
            overflow: "hidden",
            clip: "rect(1px, 1px, 1px, 1px)",
            whiteSpace: "nowrap",
          },
        }}
      >
        {children}
      </span>
    );
  }
  if (handleSpace === "reserve") {
    return (
      <span
        css={{
          "&:not(:focus):not(:focus-within):not(:active)": {
            "*": {
              color: "transparent",
              background: "transparent",
              backgroundColor: "transparent",
              border: "transparent",
              borderColor: "transparent",
              textDecorationColor: "transparent",
              boxShadow: "none",
            },
          },
        }}
      >
        {children}
      </span>
    );
  }
  return (
    <div css={{ position: "relative", zIndex: 100000 }}>
      <span
        css={{
          position: "absolute",
          top: 0,
          left: 0,
          "&:not(:focus):not(:focus-within):not(:active)": {
            position: "absolute",
            height: 1,
            width: 1,
            border: 0,
            padding: 0,
            margin: 0,
            overflow: "hidden",
            clip: "rect(1px, 1px, 1px, 1px)",
            whiteSpace: "nowrap",
          },
        }}
      >
        {children}
      </span>
    </div>
  );
};

export default VisuallyHidden;
